/* COBE PDP sections below the fold: horizontal scrollers with prev/next buttons. */
(function () {
  'use strict';
  function initScroller(root) {
    var track = root.querySelector('[data-cobe-track]');
    if (!track || root.dataset.cobeReady) return;
    root.dataset.cobeReady = '1';
    var step = function () {
      var item = track.querySelector('li');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth - 1;
      root.querySelectorAll('[data-cobe-scroll]').forEach(function (btn) {
        var dir = parseInt(btn.dataset.cobeScroll, 10);
        btn.disabled = dir < 0 ? track.scrollLeft <= 0 : track.scrollLeft >= max;
      });
    };
    root.querySelectorAll('[data-cobe-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        track.scrollBy({ left: step() * parseInt(btn.dataset.cobeScroll, 10), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  /* Reviews modal: native <dialog> holding the Loox reviews embed (an iframe that posts
     {type:'resize', frame:'looxReviewsFrame', height} to the page while it renders). The dialog opens at once with a
     skeleton of review cards; the real widget stays in the DOM, invisible and zero height, and is swapped in only when it is
     loaded and settled: the iframe has reported a real height and neither its height nor the messages changed for SETTLE ms.
     Hard stop at MAX_WAIT ms, then whatever is there is shown. A second open (already revealed) shows no skeleton. */
  var REVIEWS_SETTLE = 400, REVIEWS_EMPTY_SETTLE = 1500, REVIEWS_MAX_WAIT = 6000, REVIEWS_MIN_HEIGHT = 400;
  function reviewsSkeleton(label) {
    var card = '<div class="cobe-reviews__sk-card"><span class="cobe-reviews__sk-avatar"></span><div class="cobe-reviews__sk-col">' +
      '<span class="cobe-reviews__sk-line cobe-reviews__sk-line--name"></span><span class="cobe-reviews__sk-line cobe-reviews__sk-line--stars"></span>' +
      '<span class="cobe-reviews__sk-line"></span><span class="cobe-reviews__sk-line"></span><span class="cobe-reviews__sk-line cobe-reviews__sk-line--short"></span></div></div>';
    var el = document.createElement('div');
    el.className = 'cobe-reviews__skeleton';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-label', label || 'Loading reviews');
    el.innerHTML = new Array(6).join(card);
    return el;
  }
  function initReviewsModal(scope) {
    (scope || document).querySelectorAll('[data-cobe-reviews-open]').forEach(function (btn) {
      if (btn.dataset.cobeReady) return;
      btn.dataset.cobeReady = '1';
      var dialog = document.getElementById(btn.getAttribute('aria-controls'));
      if (!dialog) return;
      var body = dialog.querySelector('.cobe-reviews__dialog-body');
      var widget = dialog.querySelector('#looxReviews');
      var loadingText = dialog.querySelector('.cobe-reviews__loading');
      var skeleton = null, timer = null, revealed = false, openedAt = 0, lastChange = 0, lastH = -1, msgSeen = false;
      var onMessage = function (e) {
        var d = e.data;
        if (typeof d === 'string') { try { d = JSON.parse(d); } catch (err) { return; } }
        if (!d || d.type !== 'resize' || d.frame !== 'looxReviewsFrame') return;
        msgSeen = true;
        lastChange = Date.now();
      };
      function reveal() {
        if (revealed) return;
        revealed = true;
        clearInterval(timer);
        window.removeEventListener('message', onMessage);
        if (!skeleton) return;
        dialog.classList.add('is-ready');
        dialog.classList.remove('is-pending');
        widget.removeAttribute('aria-busy');
        var sk = skeleton;
        setTimeout(function () { if (sk.parentNode) sk.parentNode.removeChild(sk); dialog.classList.remove('is-ready'); }, 300);
      }
      function check() {
        var now = Date.now();
        var frame = widget.querySelector('iframe');
        var h = frame ? Math.round(frame.getBoundingClientRect().height) : 0;
        if (h !== lastH) { lastH = h; lastChange = now; }
        var quiet = now - lastChange;
        if (now - openedAt >= REVIEWS_MAX_WAIT) return reveal();
        if (!frame || !(msgSeen || now - openedAt >= 1500)) return;
        if (h > REVIEWS_MIN_HEIGHT ? quiet >= REVIEWS_SETTLE : quiet >= REVIEWS_EMPTY_SETTLE) reveal();
      }
      function startLoading() {
        if (revealed || timer || !body || !widget) return;
        openedAt = lastChange = Date.now();
        skeleton = reviewsSkeleton(loadingText && loadingText.textContent.trim());
        body.insertBefore(skeleton, widget);
        dialog.classList.add('is-pending');
        widget.setAttribute('aria-busy', 'true');
        window.addEventListener('message', onMessage);
        timer = setInterval(check, 100);
      }
      btn.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          startLoading();
          dialog.showModal();
          document.documentElement.classList.add('cobe-reviews-open');
          window.dispatchEvent(new Event('resize'));
        } else {
          dialog.setAttribute('open', '');
        }
      });
      dialog.querySelectorAll('[data-cobe-reviews-close]').forEach(function (c) { c.addEventListener('click', function () { dialog.close(); }); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', function () { document.documentElement.classList.remove('cobe-reviews-open'); });
    });
  }
  /* UGC tile videos: the Lux Steam Pro two-state player. Preview = muted loop that plays only
     while in the viewport (IntersectionObserver); sound = unmuted with native controls after
     the button. No autoplay attribute in the markup, so no video data loads before the tile
     is seen.
     In-app browsers on iPhone (TikTok for one) run a WKWebView with inline playback switched
     off by the host app, so every play() opens the native fullscreen player no matter what
     playsinline says. Known hosts skip the scroll preview from the start; any other host that
     throws a preview into fullscreen is bounced back out and flagged so no tile tries again.
     The poster stays as a still and the sound button keeps working. */
  /* iPhone WKWebView user agents carry no "Safari/" token (Safari, Chrome, Firefox and Edge on iOS all
     have it), so every in-app browser is caught, not only TikTok. Previews there show the poster. */
  var ua = navigator.userAgent;
  var inlineBlocked = /musical_ly|bytedancewebview|tiktok/i.test(ua) || (/iPhone|iPod/i.test(ua) && !/Safari\//i.test(ua));
  /* Phone debugging only (?cobe_ua=1): shows the user agent and the preview decision. */
  if (/[?&]cobe_ua=1/.test(location.search)) {
    var dbg = document.createElement('div');
    var dbgAdded = false;
    dbg.setAttribute('style', 'position:fixed;top:0;left:0;right:0;z-index:99999;background:#111;color:#0f0;font:12px/1.4 monospace;padding:8px;word-break:break-all;');
    dbg.textContent = 'inlineBlocked=' + inlineBlocked + ' | v2 | ' + ua;
    var addDbg = function () { if (dbgAdded || !document.body) return; dbgAdded = true; document.body.appendChild(dbg); };
    document.addEventListener('DOMContentLoaded', addDbg);
    addDbg();
  }
  function blockInlinePreviews() {
    inlineBlocked = true;
    document.querySelectorAll('[data-cobe-video]').forEach(function (w) {
      var i = w.__cobeVideo; if (i && i.video && i.state === 'preview') i.video.pause();
    });
  }
  function CobeVideo(wrapper) {
    this.wrapper = wrapper;
    this.video = wrapper.querySelector('video');
    this.btn = wrapper.querySelector('.cobe-ugc__play');
    this.state = 'preview';
    this.inViewport = false;
    if (!this.video) return;
    this.video.muted = true; this.video.loop = true; this.video.playsInline = true; this.video.controls = false;
    this.video.setAttribute('webkit-playsinline', '');
    this.video.removeAttribute('autoplay');
    var self = this;
    this.video.addEventListener('webkitbeginfullscreen', function () {
      if (self.state !== 'preview') return;
      if (typeof self.video.webkitExitFullscreen === 'function') { try { self.video.webkitExitFullscreen(); } catch (err) {} }
      blockInlinePreviews();
    });
    if (this.btn) this.btn.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); self.enterSound(); });
    if (typeof IntersectionObserver === 'undefined') { this.tryPlay(); return; }
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        self.inViewport = entry.isIntersecting;
        if (entry.isIntersecting) { if (self.state === 'preview') self.tryPlay(); }
        else self.video.pause();
      });
    }, { threshold: 0.25 });
    this.observer.observe(wrapper);
  }
  CobeVideo.prototype.tryPlay = function () {
    if (inlineBlocked && this.state === 'preview') return;
    var p = this.video.play(); if (p && p.catch) p.catch(function () {});
  };
  /* Sound play opens the section's lightbox <dialog> (showModal gives the backdrop, Esc, focus trap and
     inert page). The tile keeps its muted preview loop underneath. */
  CobeVideo.prototype.enterSound = function () {
    var dialog = this.wrapper.closest('.cobe-ugc') && this.wrapper.closest('.cobe-ugc').querySelector('[data-cobe-ugc-lightbox]');
    var src = this.wrapper.getAttribute('data-cobe-full');
    if (!dialog || !src || typeof dialog.showModal !== 'function') {
      this.state = 'sound'; this.video.muted = false; this.video.loop = false; this.video.controls = true; this.video.currentTime = 0;
      if (this.btn) this.btn.classList.add('is-hidden');
      this.tryPlay();
      return;
    }
    var big = dialog.querySelector('video');
    dialog.__opener = this.btn || this.wrapper;
    big.src = src;
    big.poster = this.video.poster || '';
    this.video.pause();
    document.documentElement.classList.add('cobe-ugc-lightbox-open');
    dialog.showModal();
    var p = big.play(); if (p && p.catch) p.catch(function () {});
  };
  CobeVideo.prototype.exitSound = function () {};
  function initUgcLightbox(scope) {
    (scope || document).querySelectorAll('[data-cobe-ugc-lightbox]').forEach(function (dialog) {
      if (dialog.dataset.cobeInit) return;
      dialog.dataset.cobeInit = '1';
      var big = dialog.querySelector('video');
      /* iOS native fullscreen (in-app browsers): leaving the player closes the lightbox too. */
      big.addEventListener('webkitendfullscreen', function () { if (dialog.open) dialog.close(); });
      dialog.querySelector('[data-cobe-ugc-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', function () {
        big.pause(); big.removeAttribute('src'); big.load();
        document.documentElement.classList.remove('cobe-ugc-lightbox-open');
        if (dialog.__opener && dialog.__opener.focus) dialog.__opener.focus();
        dialog.querySelectorAll('video').length && document.querySelectorAll('[data-cobe-video]').forEach(function (w) { var i = w.__cobeVideo; if (i && i.inViewport) i.tryPlay(); });
      });
    });
  }
  function initVideos(scope) {
    (scope || document).querySelectorAll('[data-cobe-video]').forEach(function (w) { if (!w.__cobeVideo) w.__cobeVideo = new CobeVideo(w); });
  }
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-cobe-video]').forEach(function (w) { if (w.__cobeVideo) { w.__cobeVideo.observer && w.__cobeVideo.observer.disconnect(); w.__cobeVideo.video && w.__cobeVideo.video.pause(); w.__cobeVideo = null; } });
  });
  /* Desktop: drag the UGC row with the mouse (wheel and touch already scroll it).
     Snap is suspended while dragging so the row tracks the pointer 1:1, and a
     drag must not fire the play button it ends on. */
  function initUgcDrag(scope) {
    (scope || document).querySelectorAll('.cobe-ugc__track').forEach(function (track) {
      if (track.dataset.cobeDrag) return;
      track.dataset.cobeDrag = '1';
      var startX = 0, startLeft = 0, active = false, moved = false;
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        active = true; moved = false;
        startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('cobe-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!active) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) moved = true;
        if (moved) track.scrollLeft = startLeft - dx;
      });
      var end = function () { active = false; track.classList.remove('cobe-dragging'); };
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-cobe-scroller]').forEach(initScroller);
    initReviewsModal(scope);
    initVideos(scope);
    initUgcLightbox(scope);
    initUgcDrag(scope);
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
